// @owners { team: patients }
import { NavBarLogo } from '@alto/design-system';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';

export const NavBar = () => {
  return (
    <NavBarLogo
      source={getImage('logo')}
      height="SM"
      width="LG"
      accessibilityLabel="logo"
      testID="navbar-logo"
    />
  );
};
